import type { PageContext } from 'vike/types'
export default function title(pageContext: PageContext): string {
  const { agent, company } = pageContext.data
  return pageContext.i18n.global.t('seo.agent.title', { name: agent.personal?.fullname ?? '', company: company.general?.name ?? '' })
}
